import { LIST_GENDER } from "../LocalConst";

export class Customer {
  id = null;
  code = null; // Patient Code
  displayName = null; // ho va ten
  birthDate = null; // ngay sinh
  age = null; //tuoi
  gender = LIST_GENDER[1].value; // gioi tinh
  phoneNumber = null; // so dien thoai
  idNumber = null; // cccd
  idNumberIssueBy = null; // noi cap cccd
  idNumberIssueDate = null; // ngay cap cccd
  email = null; // email
  nationality = null; // quoc tich
  profession = null; // nghề nghiệp
  currentWard = null; // Xã địa chỉ hiện tại
  currentDistrict = null; // Huyện địa chỉ hiện tại
  currentProvince = null; // Tỉnh địa chỉ hiện tại
  currentRegion = null; // Khu vực địa chỉ hiện tại
  currentDetailResidence = null; // Chi tiet hien tai noi dang cu tru
  relativeName = null;
  relationship = null;
  relativePhoneNumber = null;
  note = null;
  isCollaborator = false;
  firstPatientSource = null;
  currentPatientSource = null;
  currentPatientGroup = null;
  currentPatientType = null;
  currentPatientRank = null;
  currentPatientTypeService = null;
  idFacebook = null;
  idZalo = null;
  idTiktok = null;
}
